import { render } from "./ApartmentAboutBar.vue?vue&type=template&id=b3080c20"
import script from "./ApartmentAboutBar.vue?vue&type=script&lang=js"
export * from "./ApartmentAboutBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__